/**
 * House heating mode and semantic climate actions (server ha/heating.ts).
 * Additive to protocol.ts: client → `climate`, server → `heating`.
 */
import { z } from 'zod';
/** House-level heating policy derived from HA helpers (Woodlands: summer_heating, disable_heating, NeoHub away). */
export const HeatingMode = z.enum(['normal', 'summer', 'away', 'disabled']);
/** Client → server: semantic climate action on a whole system (gateway-authorised per underlying call). */
export const ClimateActionMsg = z.object({
    t: z.literal('climate'),
    id: z.number(),
    home: z.string(),
    systemId: z.string(),
    action: z.enum(['mode', 'target']),
    mode: z.enum(['off', 'heat', 'cool', 'auto']).optional(),
    which: z.enum(['single', 'low', 'high']).optional(),
    /** Target for action 'target'; optional explicit target for action 'mode' (only sent if the user chose one). */
    value: z.number().finite().optional(),
});
//# sourceMappingURL=heating.js.map